var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',_vm._g(_vm._b({staticClass:"btn-block-xs-only",attrs:{"size":"sm","variant":"success"}},'b-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Nuevo\n    ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }